import { ActionTypes } from "../constants/action-types"

const initialState = {
  newInterviewQa:[]

}

export const UploadInterviewQa = (state=initialState, {type, payload})=>{
switch (type){
    case ActionTypes.UPLOAD_INTERVIEW_QA: 
    return {...state, newInterviewQa: payload}
    default: return state
}

}

export default UploadInterviewQa